<template>
  <div>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>

export default {
  name: "TestBookingManage",
}
</script>

<style scoped>

</style>
